import type {Message} from '../hooks/use-chromeless-post-message'

export class UserVisiblePageError extends Error {
  readonly title: string
  readonly chromelessPostMessage?: Message

  constructor(x: {title: string; chromelessPostMessage?: Message}) {
    super(x.title)
    this.title = x.title
    this.chromelessPostMessage = x.chromelessPostMessage
    this.name = 'UserVisiblePageError'
  }
}
